export const PrivateFolder = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8243 9.58795H24.7466C24.9859 9.58795 25.2153 9.68091 25.3845 9.84639C25.5536 10.0119 25.6487 10.2363 25.6487 10.4703V22.8232C25.6487 23.0573 25.5536 23.2817 25.3845 23.4472C25.2153 23.6126 24.9859 23.7056 24.7466 23.7056H4.90203C4.6628 23.7056 4.43336 23.6126 4.2642 23.4472C4.09504 23.2817 4 23.0573 4 22.8232V12.235"
      fill="#F2D1D5"
    />
    <path
      d="M10.9118 12.235H4V7.82324C4 7.58923 4.09504 7.3648 4.2642 7.19932C4.43336 7.03385 4.6628 6.94089 4.90203 6.94089H10.9118C11.1068 6.94167 11.2965 7.00351 11.453 7.11736L14.8243 9.58795L11.453 12.0585C11.2965 12.1724 11.1068 12.2342 10.9118 12.235Z"
      fill="#E5A3AC"
    />
    <path
      d="M26.747 18.3768V17.9591C26.747 17.1837 26.439 16.4401 25.8907 15.8919C25.3424 15.3436 24.5988 15.0356 23.8234 15.0356C23.0481 15.0356 22.3045 15.3436 21.7562 15.8919C21.2079 16.4401 20.8999 17.1837 20.8999 17.9591V18.3768H19.647V23.8062C19.647 24.1385 19.779 24.4572 20.014 24.6921C20.2489 24.9271 20.5676 25.0591 20.8999 25.0591H26.747C27.0793 25.0591 27.398 24.9271 27.6329 24.6921C27.8679 24.4572 27.9999 24.1385 27.9999 23.8062V18.3768H26.747ZM24.2411 22.5532H23.4058V20.8826H24.2411V22.5532ZM25.9117 18.3768H21.7352V17.9591C21.7352 17.4053 21.9552 16.8741 22.3468 16.4825C22.7385 16.0909 23.2696 15.8709 23.8234 15.8709C24.3773 15.8709 24.9084 16.0909 25.3 16.4825C25.6917 16.8741 25.9117 17.4053 25.9117 17.9591V18.3768Z"
      fill="#A09CAD"
    />
  </svg>
);
